import styled from "@emotion/styled";

import { fontRoboto, theme } from "shared/lib/styles";

import { TopicLink } from "scmp-app/components/topic/topic-link";

export const StyledTopicLink = styled(TopicLink)``;

export const StyledTopic = styled.div`
  padding-block: 12px;
  padding-inline: 0;

  text-align: center;

  ${theme.breakpoints.up("tablet")} {
    padding-block: 14px;
    padding-inline: 0;
  }

  ${StyledTopicLink} {
    color: #4585ff;
    font-weight: 700;
    font-size: 16px;
    font-family: ${fontRoboto};
    line-height: 20px;

    ${theme.breakpoints.up("tablet")} {
      font-weight: 700;
      font-size: 20px;
      font-family: ${fontRoboto};
      line-height: 24px;
    }
  }
`;
